import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import { getAuthConfig } from "./config.js";
import { isHostAuthActive } from "./hostAuth.js";
let manager = null;
function buildSettings() {
    const config = getAuthConfig();
    const userStore = new WebStorageStateStore({ store: globalThis.localStorage });
    // stateStore holds the ephemeral OIDC state (the `state` value, nonce, PKCE
    // code_verifier) for the duration of the login redirect round-trip. It MUST be
    // localStorage, not sessionStorage: a magic-link sign-in is initiated in one tab
    // but completes in another (the link is opened from an email client in a new
    // tab), and sessionStorage is tab-scoped; the callback tab would see an empty
    // store and signinRedirectCallback() throws "No matching state found in storage".
    // localStorage is shared across same-origin tabs in the browser, so the resumed
    // flow finds its state. This does not weaken the CSRF guarantee: `state` is still
    // bound to this browser/origin and validated against what we stored. Stale entries
    // from abandoned logins are swept by clearStaleState() below. Matches the client
    // preset in ../client/index.ts, which already stores both here.
    const stateStore = new WebStorageStateStore({ store: globalThis.localStorage });
    return {
        authority: config.authority,
        client_id: config.clientId,
        redirect_uri: config.redirectUri,
        post_logout_redirect_uri: config.postLogoutRedirectUri,
        silent_redirect_uri: config.silentRedirectUri,
        response_type: "code",
        scope: config.scope ?? "openid profile email",
        userStore,
        stateStore,
        loadUserInfo: true,
        // The hidden-iframe silent renew relies on the Keycloak SSO cookie, which
        // is absent inside the desktop Tauri webview. In host-auth mode the desktop
        // host owns refresh, so disable it to avoid futile renew attempts.
        automaticSilentRenew: !isHostAuthActive(),
        redirectMethod: "replace",
    };
}
export function getUserManager() {
    if (!manager) {
        manager = new UserManager(buildSettings());
        // Now that state lives in localStorage (shared across tabs, survives restart),
        // sweep expired entries left by abandoned/interrupted logins so they don't
        // accumulate. Keyed, single-use entries mean this can't disturb an in-flight
        // login. Fire-and-forget: cleanup failure must not block getting the manager.
        void manager.clearStaleState().catch(() => { });
    }
    return manager;
}
export function resetUserManager() {
    manager = null;
}
//# sourceMappingURL=userManager.js.map